// Model options for the optional AI summary.
//
// Kept free of any `@huggingface/transformers` import on purpose: the page needs
// these to render its dropdown, and importing them from llmSummary.js would
// drag the whole v4 runtime into the main bundle (and, in Jest, pull in the
// Node-only `sharp` dependency). llmSummary.js itself only ever loads inside
// the analysis worker.

export const LLM_MODELS = [
  {
    id: 'onnx-community/Qwen2.5-0.5B-Instruct',
    label: 'Fast (Qwen2.5 0.5B)',
    size: '~350 MB',
    note: 'Quickest. Fine for a short call; can get vague on long interviews.',
  },
  {
    id: 'onnx-community/Llama-3.2-1B-Instruct',
    label: 'Better (Llama 3.2 1B)',
    size: '~800 MB',
    note: 'Noticeably better summaries. Slower, and a large first download.',
  },
];

export const DEFAULT_LLM = LLM_MODELS[0].id;

export function llmInfo(id) {
  return LLM_MODELS.find(m => m.id === id) || LLM_MODELS[0];
}

/** WebGPU makes this usable; WASM makes it a coffee break. */
export function hasWebGpu() {
  return typeof navigator !== 'undefined' && !!navigator.gpu;
}
